module.exports = __webpack_public_path__ + "media/images/favicon-0a5ef59027d45ce9e508969b2d7de5a2.ico";